import LogActivityActions from './actions';

const INITIAL_STATE = {
  data: {},
  isProcessing: false,
  isError: false,
  errorMessage: [],
  form:{},
  isNewRecord:false,
  showModal:false,
  onSubmit:false,
  single:null,
  helperLogActivity:[],
  errorInternal:false
};

function LogActivityReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case LogActivityActions.RESET_LIST:
      return { ...state,errorInternal:false,onSubmit:false, isProcessing: false,single:null, form:INITIAL_STATE.form,data:{}};
    case LogActivityActions.NEW_DATA:
      return { ...state,errorInternal:false,onSubmit:false, isProcessing: false,single:null, errorMessage:[],form:INITIAL_STATE.form,isNewRecord:true,showModal:true};
    case LogActivityActions.UPDATE_DATA:
      return { ...state, errorInternal:false,onSubmit:false,isProcessing: false, single:null,isNewRecord:false};
    case LogActivityActions.VIEW_DATA:
      return { ...state, errorInternal:false,onSubmit:false,isProcessing: false, single:action.payload,errorMessage:[],isNewRecord:false,showModal:true};
    case LogActivityActions.RESET_DATA:
      return { ...state,errorInternal:false,onSubmit:false, isProcessing: false, form:INITIAL_STATE.form,showModal:false};
    case LogActivityActions.DELETE_DATA:
      return { ...state, errorInternal:false,onSubmit:false,isProcessing: false, form:INITIAL_STATE.form,showModal:false};
    case LogActivityActions.ON_SUBMIT:
      return { ...state, errorInternal:false,onSubmit:true};
    case LogActivityActions.SHOW_DATA:
      return { ...state, errorInternal:false,onSubmit:false, isError: false, data: action.payload, errorMessage: [],isProcessing:false };
    case LogActivityActions.ERROR_DATA:
      return { ...state, errorInternal:false, isError: true,onSubmit:false,  errorMessage: action.payload,isProcessing:false };
    case LogActivityActions.SUCCESS_DATA:
      return { ...state,errorInternal:false,onSubmit:false, isError: false, showModal:false,form:INITIAL_STATE.form , onSubmit:false};
    case LogActivityActions.PROCESS_DATA:
      return { ...state, errorInternal:false,onSubmit:false,isProcessing: true, isError: false,isSuccess:false};
    case LogActivityActions.GET_HELPER_LOGACTIVITY:
      return { ...state,errorInternal:false, isError: false,isSuccess:false,onSubmit:false,helperLogActivity:action.payload};
    case LogActivityActions.ERROR_SERVER:
      return { ...state,  isError: false, errorInternal:true, onSubmit:false,  errorMessage: action.payload, isProcessing:false };
    case LogActivityActions.APPROVE:
      return { ...state,errorInternal:false,  isError: false,isSuccess:false,onSubmit:false,};
    case LogActivityActions.REJECT:
      return { ...state,errorInternal:false,  isError: false,isSuccess:false,onSubmit:false,};
     
    default:
      return state;
    }
}

export default LogActivityReducer;
